var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5327",
    "data-name": "Group 5327",
    transform: "translate(-404.5 -225.757)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(405 226.257)",
    fill: "#FF3535",
    stroke: "#FF3535",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(415.532 234.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path929",
    d: "M7.07,288.8a5.755,5.755,0,0,0-5.748,5.748c0,5.575,5.424,9.814,5.424,9.814a.523.523,0,0,0,.652,0s5.424-4.238,5.424-9.814A5.759,5.759,0,0,0,7.07,288.8Zm0,1.045a4.7,4.7,0,0,1,4.706,4.7c0,4.561-4.13,8.164-4.7,8.652-.57-.486-4.706-4.09-4.706-8.652A4.694,4.694,0,0,1,7.07,289.842Z",
    transform: "translate(-1.322 -288.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle931",
    d: "M5.751,290.385A2.843,2.843,0,1,0,8.6,293.226,2.849,2.849,0,0,0,5.751,290.385Zm0,1.137a1.706,1.706,0,1,1-1.7,1.7A1.7,1.7,0,0,1,5.751,291.522Z",
    transform: "translate(-0.004 -287.386)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.1c9e612c44abfabd8228c0561b0aea03.svg";
export { ForwardRef as ReactComponent };